(function (window, document, undefined) {
  var ModalAlertProposte = function (
    $scope,
    $modalInstance,
    gestioneRaccomandazioneService,
    messaggiFctr,
    labelSrvc,
    CONSTANTS
  ) {
    this.messaggiFctr = messaggiFctr;
    $scope.msg = labelSrvc.getLabel;

    this.service = gestioneRaccomandazioneService;

    this.close = function () {
      $modalInstance.dismiss();
    };
  };

  ModalAlertProposte.$inject = [
    '$scope',
    '$uibModalInstance',
    'gestioneRaccomandazioneService',
    'FinMessaggiFctr',
    'FinLabelSrvc',
    'FIN_CONSTANTS'
  ];

  angular
    .module('cbl.finanza.mf')
    .controller('ModalAlertProposte', ModalAlertProposte);
})(window, document);



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/modalAlertProposte/modalAlertProposte.ctrl.js
 ** module id = 45
 ** module chunks = 1 2
 **/